import { useQuery } from '@tanstack/react-query';

import { fetchCargoClaimApi } from '../api';

/*
 * One claim, with its lines and documents.
 *
 * Scoped by the service against the caller's policy holders, and a claim
 * outside them answers 404 rather than 403 — references are sequential, so
 * "exists but not yours" would confirm which ones are real.
 */
export default function useCargoClaimQuery(reference?: string, options?: any) {
  return useQuery(['cargo', 'claim', reference], fetchCargoClaimApi, {
    enabled: Boolean(reference),
    ...options,
  });
}
